import { load } from 'services/utility/image/resizeImage';

export const getImageResolution = async (loadImage: string) => {
  const loadedImage = await load(loadImage);
  return { width: loadedImage.width, height: loadedImage.height };
};
